import * as React from 'react'
import classNames from 'classnames'

import Search from 'ui-component-library/icons/search.svg'

import style from './style.scss'

export const DEFAULT_CLOSE_ICON_LABEL_TEXT = 'Close search'
export const DEFAULT_SEARCH_ICON_LABEL_TEXT = 'Open search'

export type Props = {
  className?: string
  closeIconLabelText?: string
  isActive?: boolean
  onClick: () => void
  searchIconLabelText?: string
}

SearchButton.defaultProps = {
  closeIconLabelText: DEFAULT_CLOSE_ICON_LABEL_TEXT,
  searchIconLabelText: DEFAULT_SEARCH_ICON_LABEL_TEXT,
}

function SearchButton(props: Props) {
  const {
    className,
    closeIconLabelText,
    onClick,
    isActive = false,
    searchIconLabelText,
  } = props

  return (
    <button
      className={classNames(
        style.wrapper,
        { [style.active]: isActive },
        className,
      )}
      id='search-icon-button'
      onClick={onClick}
      aria-label={isActive ? closeIconLabelText : searchIconLabelText}
    >
      <Search className={classNames(style.iconOpen, style.light)} />
    </button>
  )
}

export default SearchButton
